import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import {
  SixtyFourtyBlock, Column,
  ColumnGroup
} from "containers"

const VehicleResourceList = ({
  title, imageUrl, size, vehicleResources
}) => (
  <ColumnGroup horizontalPadding={false}>
    <Column padding>
      <SixtyFourtyBlock
        heading={title}
        textAlign="left"
        imagePosition="right"
        size={size}
        backgroundSize="contain"
        headingUppercase
        textVerticalAlign="center"
        imageUrl={imageUrl}>
        {vehicleResources && vehicleResources.items.map((item) => {
          return (
            <p style={{ marginBottom: "1em" }} key={item.href}>
              <a
                href={item.href}
                style={{
                  color: "#101010", fontWeight: "200", borderBottom: "none", textDecoration: "none"
                }}>
                <img style={{ display: "inline", marginRight: "1em" }} src={`/globalassets/mymazda/${item.isExternal ? "icon_external-link" : "icon_download"}.svg`} height="16" width="19" />
                {item.label}
              </a>
            </p>
          )
        })}
      </SixtyFourtyBlock>
    </Column>
  </ColumnGroup>
)
export default Radium(VehicleResourceList)

VehicleResourceList.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  size: PropTypes.string,
  vehicleResources: PropTypes.object
}

VehicleResourceList.defaultProps = {
  size: "small"
}



// WEBPACK FOOTER //
// ./src/components/mymazda/vehicle-resource-list/index.jsx